var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/facet-option.j2"] = require( "macros/facet-option.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-color-facet.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
env.getTemplate("macros/facet-option.j2", false, "category/templates/facets/category-color-facet.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("facetOption")) {
var t_4 = t_1.facetOption;
} else {
cb(new Error("cannot import 'facetOption'")); return;
}
context.setVariable("facetOption", t_4);
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"refinements");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("facet", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
var t_9;
t_9 = runtime.memberLookup((t_8),"name");
frame.set("facetName", t_9, true);
if(frame.topLevel) {
context.setVariable("facetName", t_9);
}
if(frame.topLevel) {
context.addExport("facetName", t_9);
}
var t_10;
t_10 = env.getFilter("lower").call(context, env.getFilter("sanitize_attr").call(context, runtime.memberLookup((t_8),"value")));
frame.set("facetValue", t_10, true);
if(frame.topLevel) {
context.setVariable("facetValue", t_10);
}
if(frame.topLevel) {
context.addExport("facetValue", t_10);
}
var t_11;
t_11 = env.getFilter("lower").call(context, env.getFilter("replace").call(context, runtime.memberLookup((t_8),"value"),"/","-"));
frame.set("facetValueMatch", t_11, true);
if(frame.topLevel) {
context.setVariable("facetValueMatch", t_11);
}
if(frame.topLevel) {
context.addExport("facetValueMatch", t_11);
}
output += "\n    ";
var t_12;
t_12 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("inLineBackground", t_12, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_12);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_12);
}
output += "\n    ";
var t_13;
t_13 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("inLineStyle", t_13, true);
if(frame.topLevel) {
context.setVariable("inLineStyle", t_13);
}
if(frame.topLevel) {
context.addExport("inLineStyle", t_13);
}
output += "\n    ";
var t_14;
t_14 = runtime.memberLookup((t_8),"value");
frame.set("displayName", t_14, true);
if(frame.topLevel) {
context.setVariable("displayName", t_14);
}
if(frame.topLevel) {
context.addExport("displayName", t_14);
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"colorFacets")) {
output += "\n\n        ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"colorFacets")),runtime.contextOrFrameLookup(context, frame, "facetValueMatch"));
frame.set("colorFacetConfig", t_15, true);
if(frame.topLevel) {
context.setVariable("colorFacetConfig", t_15);
}
if(frame.topLevel) {
context.addExport("colorFacetConfig", t_15);
}
if(runtime.contextOrFrameLookup(context, frame, "facetName") == "color" && runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")) {
output += "\n\n            ";
output += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode")) {
output += "\n\n                ";
var t_16;
t_16 = "background: #" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode");
frame.set("inLineBackground", t_16, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_16);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_16);
}
output += "\n\n            ";
;
}
output += "\n\n            ";
output += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl")) {
output += "\n\n                ";
var t_17;
t_17 = "background: url(" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl") + "" + ") repeat;background-size: cover;";
frame.set("inLineBackground", t_17, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_17);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_17);
}
output += "\n\n            ";
;
}
output += "\n\n            ";
output += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode")) {
output += "\n\n                ";
var t_18;
t_18 = "background: #" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode") + "" + " url(" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl") + "" + ") repeat;background-size: cover";
frame.set("inLineBackground", t_18, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_18);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_18);
}
output += "\n\n            ";
;
}
output += "\n\n            ";
var t_19;
t_19 = "style=\"" + "" + runtime.contextOrFrameLookup(context, frame, "inLineBackground") + "" + "\"";
frame.set("inLineStyle", t_19, true);
if(frame.topLevel) {
context.setVariable("inLineStyle", t_19);
}
if(frame.topLevel) {
context.addExport("inLineStyle", t_19);
}
output += "\n\n            ";
output += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"displayName")) {
output += "\n\n                ";
var t_20;
t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"displayName");
frame.set("displayName", t_20, true);
if(frame.topLevel) {
context.setVariable("displayName", t_20);
}
if(frame.topLevel) {
context.addExport("displayName", t_20);
}
output += "\n\n            ";
;
}
output += "\n\n        ";
;
}
output += "\n\n    ";
;
}
var t_21;
t_21 = runtime.contextOrFrameLookup(context, frame, "facetName") + "" + "-_-" + "" + runtime.contextOrFrameLookup(context, frame, "facetValue");
frame.set("analyticsSlug", t_21, true);
if(frame.topLevel) {
context.setVariable("analyticsSlug", t_21);
}
if(frame.topLevel) {
context.addExport("analyticsSlug", t_21);
}
var t_22;
t_22 = (runtime.contextOrFrameLookup(context, frame, "showResultsCount")?runtime.memberLookup((t_8),"count"):0);
frame.set("refinementsCount", t_22, true);
if(frame.topLevel) {
context.setVariable("refinementsCount", t_22);
}
if(frame.topLevel) {
context.addExport("refinementsCount", t_22);
}
output += runtime.suppressValue((lineno = 60, colno = 16, runtime.callWrap(t_4, "facetOption", context, [runtime.contextOrFrameLookup(context, frame, "category"),t_8,runtime.contextOrFrameLookup(context, frame, "displayName"),runtime.contextOrFrameLookup(context, frame, "facetName"),runtime.contextOrFrameLookup(context, frame, "facetValue"),runtime.makeKeywordArgs({"gaAttributes": (lineno = 61, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 61, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"filter by " + "" + runtime.contextOrFrameLookup(context, frame, "facetName"),runtime.contextOrFrameLookup(context, frame, "facetValue"),{"no_of_results": runtime.memberLookup((t_8),"count")}])),"listItemDataAttributes": "data-facet-value=\"" + "" + env.getFilter("escape_html_attributes").call(context, runtime.contextOrFrameLookup(context, frame, "facetValue")) + "" + "\"","inLineStyle": runtime.contextOrFrameLookup(context, frame, "inLineStyle"),"refinementsCount": runtime.contextOrFrameLookup(context, frame, "refinementsCount")})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-color-facet.j2"] , dependencies)